require('./lbaPointsOfInterestItemForm.scss');

const lbaPointsOfInterestItemForm = angular.module('app.lbaPointsOfInterestItemForm', []);

lbaPointsOfInterestItemForm.component('lbaPointsOfInterestItemForm', {
  bindings: {
    pointOfInterest: '=',
    toggleDetail: '=',
    saveItem: '=',
    deleteItem: '='
  },
  controller: ['lbaLeafletMapService', lbaPointsOfInterestItemFormCtrl],
  template: `
    <div class="lbaPointsOfInterest_ItemForm">
      <div class="lbaPointsOfInterest_ItemForm_header">
        <h3 ng-if="!$ctrl.update">New</h3>
        <h3 ng-if="$ctrl.update">Edit</h3>
        <button class="lbaPointsOfInterest_ItemForm_back btn" ng-click="$ctrl.toggleDetail()"><span class="fa fa-chevron-left"></span></button>
      </div>

      <form>
        <div class="form-group">
          <label>Title</label>
          <input type="text" ng-model="$ctrl.tempPointOfInterest.Title" placeholder="Name" class="form-control" >
        </div>

        <div class="form-group">
          <label>Description</label>
          <textarea ng-model="$ctrl.tempPointOfInterest.Description" placeholder="Description" class="form-control" ></textarea>
        </div>

        <div class="form-group">
          <label>Address</label>
          <textarea ng-model="$ctrl.tempPointOfInterest.Address" placeholder="Address" class="form-control" ng-change="$ctrl.clearErrors()" ></textarea>
        </div>
        <div class="form-group">
          <div>
            <button class="btn lbaPointsOfInterest_addPosition" ng-click="$ctrl.addPosition()"><span class="fa fa-thumb-tack"></span></button>
            <label>Position</label>
            <p class="error text-warning" ng-if="$ctrl.errors.position">{{$ctrl.errors.position}}</p>
          </div>
          <label>Longitude</label>
          <input type="text" ng-model="$ctrl.tempPointOfInterest.Longitude" placeholder="Longitude" class="form-control" >
        </div>
        <div class="form-group">
        <label>Latitude</label>
          <input type="text" ng-model="$ctrl.tempPointOfInterest.Latitude" placeholder="Latitude" class="form-control" >
        </div>

        <div class="form-group">
          <p>
            <button class="btn-primary btn lbaPointsOfInterest_saveItem" ng-click="$ctrl.savePointOfInterest()" ng-if="!$ctrl.update" ng-disabled="$ctrl.saving">Save</button>
            <button class="btn-primary btn lbaPointsOfInterest_saveItem" ng-click="$ctrl.updatePointOfInterest()" ng-if="$ctrl.update" ng-disabled="$ctrl.saving">Update</button>
          </p>
        </div>
        <div class="form-group">
          <p>
            <button class="btn-danger btn lbaPointsOfInterest_deleteItem" ng-click="$ctrl.deletePointOfInterest()" ng-if="$ctrl.update" ng-disabled="$ctrl.saving">Delete</button>
          </p>
          <p class="error text-warning">{{$ctrl.errors.delete}}</p>
        </div>
      </form>
    </div>
  `
});

function lbaPointsOfInterestItemFormCtrl(lbaLeafletMapService) {
  let $ctrl = this;

  $ctrl.tempPointOfInterest = {};
  $ctrl.saving = false;
  $ctrl.update = false;
  $ctrl.errors = {};

  if($ctrl.pointOfInterest) {
    $ctrl.update = true;
    angular.copy($ctrl.pointOfInterest, $ctrl.tempPointOfInterest);
  }

  $ctrl.savePointOfInterest   = savePointOfInterest;
  $ctrl.deletePointOfInterest = deletePointOfInterest;
  $ctrl.updatePointOfInterest = updatePointOfInterest;
  $ctrl.addPosition           = addPosition;
  $ctrl.clearErrors           = clearErrors;

  function savePointOfInterest(){
    $ctrl.saving = true;
    $ctrl.saveItem($ctrl.tempPointOfInterest)
      .then(result=>{
        $ctrl.saving = false;
        $ctrl.toggleDetail();
      })
  }

  function updatePointOfInterest(){
    $ctrl.saving = true;
    $ctrl.saveItem($ctrl.tempPointOfInterest)
      .then(result=>{
        $ctrl.saving = false;
        $ctrl.toggleDetail();
      });
  }

  function clearErrors(){
    $ctrl.errors = {};
  }

  function deletePointOfInterest(){
    $ctrl.saving = true;

    $ctrl.deleteItem($ctrl.tempPointOfInterest.Id)
      .then(result=>{
        $ctrl.saving = false;
        $ctrl.toggleDetail();
      })
      .catch((data)=>{
        $ctrl.saving = false;
        $ctrl.errors.delete = 'Error deleting item';
      });
  }

  function addPosition(){
    if($ctrl.tempPointOfInterest.Address){
      lbaLeafletMapService.getPosByAddress($ctrl.tempPointOfInterest.Address)
        .then(data=>{
          if (data){
            $ctrl.tempPointOfInterest.Longitude = data.long;
            $ctrl.tempPointOfInterest.Latitude = data.lat;
          } else {
            $ctrl.errors.position = 'problem recognising address';
          }
        })
        .catch(data=>{
          $ctrl.errors.position = 'problem recognising address';
        });
    }
  }

}

export default lbaPointsOfInterestItemForm;


// WEBPACK FOOTER //
// ./src/components/lbaPointsOfInterestItemForm/lbaPointsOfInterestItemForm.js